const isProduction = process.env.REACT_APP_ENV === 'production';

export const DOMAIN = isProduction ?
  `${window.location.origin}/crystalcrush`
  : 'https://pg-stage.rpd.cloud/crystalcrush';
export const API = `${DOMAIN}/api`;

export const TRANSLATION_URL = isProduction ? `${window.location.origin}/translations/api/v1` : 'https://rpd-translations-stage.betcoapps.com/api/v1';

export const API_VERSION = 'v1';

export const ENDPOINT = 'game';
export const DEMO_ENDPOINT = 'demoGame';

const getEndpoint = isDemo => isDemo ? DEMO_ENDPOINT : ENDPOINT;

/** game service endpoints */
export const getSpinUrl = ({
  v = API_VERSION,
  isDemo = false,
} = {}) => `${API}/${v}/${getEndpoint(isDemo)}/spin`;

export const getBonusSpinUrl = ({
  v = API_VERSION,
  isDemo = false,
} = {}) => `${API}/${v}/${getEndpoint(isDemo)}/bonusSpin`;

export const getPreBonusSpinUrl = ({
  v = API_VERSION,
  isDemo = false,
} = {}) => `${API}/${v}/${getEndpoint(isDemo)}/preBonusSpin`;

export const getBuyBonusUrl = ({
  v = API_VERSION,
  isDemo = false,
} = {}) => `${API}/${v}/${getEndpoint(isDemo)}/buyBonus`;

export const getInitialStateUrl = ({
  v = API_VERSION,
  isDemo = false,
} = {}) => `${API}/${v}/${getEndpoint(isDemo)}/initialState`;

/** statistics service endpoints */
export const getLastResultsUrl = ({
  v = API_VERSION,
} = {}) => `${API}/${v}/statistics/lastResults`;

export const getGameHistoryUrl = ({
  v = API_VERSION,
} = {}) => `${API}/${v}/statistics/gameHistory`;

/** player service endpoints */
export const getBalanceUrl = ({
  v = API_VERSION,
} = {}) => `${API}/${v}/Player/balance`;

export const translationUrl = () => (
  `${TRANSLATION_URL}/Translations/Code/Game`
)
